const collapse = (editor) => {

    editor.BlockManager.add(`Collapse`, {
        category: 'Components',
        label: `
          <svg  width='1.2vw' height='1.2vw' version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 469.333 469.333" style="enable-background:new 0 0 469.333 469.333;" xml:space="preserve">
          <g>
            <g>
              <polygon points="93.44,136.107 65.707,164.48 106.24,204.8 127.787,213.333 0,213.333 0,256 127.573,256 106.88,263.68
                65.707,304.853 93.653,332.8 192,234.453 		"/>
            </g>
          </g>
          <g>
            <g>
              <polygon points="469.333,213.333 341.547,213.333 363.093,204.8 403.627,164.48 375.893,136.107 277.333,234.453 375.68,332.8
                403.627,304.853 362.453,263.68 341.76,256 469.333,256 		"/>
            </g>
          </g>
          <g>
            <g>
              <polygon points="234.453,277.333 136.107,375.893 164.48,403.627 204.8,363.093 213.333,341.547 213.333,469.333 256,469.333
                256,341.76 263.68,362.453 304.853,403.627 332.8,375.68 		"/>
            </g>
          </g>
          <g>
            <g>
              <polygon points="304.853,65.707 263.68,106.88 256,127.573 256,0 213.333,0 213.333,127.787 204.8,106.24 164.48,65.707
                136.107,93.44 234.453,192 332.8,93.653 		"/>
            </g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
          <div class="gjs-fontFamily gjs-block-label">Collapse </div>
          `,
        attributes: {},
        content: `
            <p>
              <a class="btn btn-primary" data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                Link with href
              </a>
              <button class="btn btn-primary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                Button with data-bs-target
              </button>
            </p>
            <div class="collapse" id="collapseExample">
              <div class="card card-body">
                Some placeholder content for the collapse component. This panel is hidden by default but revealed when the user activates the relevant trigger.
              </div>
            </div>
          `
      });


}

export default collapse;